module.exports = __webpack_public_path__ + "img/company-honor.5b14b362.png";